// extracted by mini-css-extract-plugin
module.exports = {"socialButtons":"Login_socialButtons__C9LyP"};